var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
import { updatePublisher } from "./publisherService";
// Function to fetch ARES updates
export var fetchAresUpdates = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var offset, limit, sortBy, searchParams, query, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                offset = filters.offset, limit = filters.limit, sortBy = filters.sortBy;
                searchParams = new URLSearchParams();
                // Use defaults if not provided
                searchParams.append("limit", "".concat(limit !== null && limit !== void 0 ? limit : 50));
                searchParams.append("offset", "".concat(offset !== null && offset !== void 0 ? offset : 0));
                query = sortBy ? "status=CREATED sortBy ".concat(sortBy) : "status=CREATED";
                searchParams.append("query", query);
                return [4 /*yield*/, kyInstance.get("ares-update-requests", {
                        headers: getHeaders(),
                        searchParams: searchParams,
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _a.sent();
                return [2 /*return*/, {
                        aresUpdateRequests: data.aresUpdateRequests,
                        totalRecords: data.totalRecords,
                    }];
        }
    });
}); };
/**
 * Loads the value of the most recently created prefix (by `dateCreated`) of
 * each given publisher with ONE request; the agency picks the latest prefix.
 * Publishers without a prefix are missing from the result.
 *
 * @param kyInstance okapi ky instance
 * @param publisherSourceIds publisher ids used across modules (at most 100,
 *   one table page)
 * @returns latest prefix value keyed by publisher source id
 */
export var fetchLatestPublisherPrefixes = function (kyInstance, publisherSourceIds) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response, data;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (publisherSourceIds.length === 0) {
                    return [2 /*return*/, {}];
                }
                searchParams = new URLSearchParams();
                searchParams.append("publisherSourceIds", publisherSourceIds.join(","));
                return [4 /*yield*/, kyInstance.get("publisher-prefixes/latest", {
                        headers: getHeaders(),
                        searchParams: searchParams,
                    })];
            case 1:
                response = _b.sent();
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _b.sent();
                return [2 /*return*/, Object.fromEntries(((_a = data.items) !== null && _a !== void 0 ? _a : []).map(function (item) { return [item.publisherSourceId, item.value]; }))];
        }
    });
}); };
// Function to fetch ARES update data by ID
export var fetchAresUpdatesData = function (id, ky) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.get("ares-update-requests/".concat(id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var aresDataSynchronize = function (kyInstance, companyNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("ares-data/".concat(companyNumber, "/synchronize"), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var aresDataSynchronizeAll = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("ares-data/update", {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var updateAres = function (ky, id, formValues) { return __awaiter(void 0, void 0, void 0, function () {
    var jsonData, resolveResponse;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!formValues.id) {
                    throw new Error("Publisher id is required to save ARES updates");
                }
                jsonData = __assign(__assign({}, formValues), { mainAddress: formValues.mainAddress || undefined, mailingAddress: formValues.mailingAddress || undefined, alternativeNames: ((_a = formValues.alternativeNames) === null || _a === void 0 ? void 0 : _a.map(function (altName) { return ({
                        name: altName.name,
                        nameSuffix: altName.nameSuffix,
                        qualifier: altName.qualifier,
                        type: altName.type || undefined,
                        nonPublic: altName.nonPublic,
                        publisher: altName.publisher,
                    }); })) || [], contacts: ((_b = formValues.contacts) === null || _b === void 0 ? void 0 : _b.map(function (contact) { return ({
                        type: contact.type,
                        value: contact.value,
                    }); })) || [], guarantors: ((_c = formValues.guarantors) === null || _c === void 0 ? void 0 : _c.map(function (guarantor) { return (__assign({}, guarantor)); })) || [] });
                return [4 /*yield*/, updatePublisher(ky, formValues.id, jsonData)];
            case 1:
                _d.sent();
                return [4 /*yield*/, ky.post("ares-update-requests/".concat(id, "/resolve"), {
                        headers: getHeaders(),
                    })];
            case 2:
                resolveResponse = _d.sent();
                if (!resolveResponse.ok) {
                    throw new Error("Error: ".concat(resolveResponse.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
